module.exports = __webpack_public_path__ + "img/team-1.c218437e.jpg";